// extracted by mini-css-extract-plugin
module.exports = {"container":"i_CI","heading":"i_CJ","features":"i_CK","feature":"i_CL","link":"i_CM","icon":"i_CN","dark":"i_CO"};